module.exports = __webpack_public_path__ + "1e36ec69ab9ec8ac78c369b4d6774453.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/step4.png
// module id = 872
// module chunks = 3